import Vue from 'vue';

window.tabComponents.ProjectTemplates = {
	component: () => import(/* webpackChunkName: "ProjectTemplates" */ '../tabs/project-templates/ProjectTemplates'),
	props: () => {
		let projectTypesSetting = $.getSettingDefinitionFromSet($.projectSettings, 'projectType');
		let projectTypes = projectTypesSetting ? projectTypesSetting.options : [];

		return {
			plicOrgId: $.PlicOrgId,
			projectTypes: projectTypes,
			projectTemplates: $.ProjectTemplates,
			projectTypeFieldSets: $.projectTypeFieldSets,
			allowCustomTypes: process.env.VUE_APP_PLIC_APP_SLUG === 'plic-elements'
		};
	},
	events: {
		'edit-template': function(template) {
			$.activeProjectTemplate = template;
			$.managementTabs.tab('change tab', 'ProjectTemplate.html');
		}
	}
};
window.tabComponents.ProjectTemplate = {
	component: () => import(/* webpackChunkName: "ProjectTemplate" */ '../tabs/project-templates/ProjectTemplate'),
	props: () => {
		let projectTypesSetting = $.getSettingDefinitionFromSet($.projectSettings, 'projectType');
		let projectTypes = projectTypesSetting ? projectTypesSetting.options : [];

		return {
			template: $.activeProjectTemplate,
			projectTypes: projectTypes,
			projectTemplates: $.ProjectTemplates,
			plicOrgId: $.UserPlicOrgId,
			allowCustomTypes: process.env.VUE_APP_PLIC_APP_SLUG === 'plic-elements'
		};
	},
	events: {
		back: function() {
			window.returnToPreviousTab();
		},
		'update-template': function(newTemplateData) {
			newTemplateData.projectTypes.forEach(function(projectType) {
				var editableFields = newTemplateData.editableFields.map(function(editableField) {
					return $.extend(true, {}, editableField);
				});

				if($.projectTypeFieldSets[projectType]) {
					$.projectTypeFieldSets[projectType].editableFields = editableFields;
				} else {
					$.projectTypeFieldSets[projectType] = {
						editableFields: editableFields
					};
				}
			});

			newTemplateData.projectTypes.forEach(type => {
				let projectType = $.projectSettings.find(function(setting) {
					return setting.name === 'projectType';
				});
				if(projectType) {
					let extras = projectType.extras;
					if(typeof extras === 'string') {
						extras = JSON.parse(extras);
						if(!extras.options.includes(type)) {
							extras.options.push(type);
							projectType.extras = JSON.stringify(extras);
						}
					}
				}
			});
		}
	}
};


import ParentSubjectUploads from '../tabs/subject-management/parent-uploads/ParentSubjectUploads.vue';
Vue.component('parent-subject-uploads', ParentSubjectUploads);
// TODO: Remove after tests migrated
import ParentSubjectUploadCard from '../tabs/subject-management/parent-uploads/ParentSubjectUploadCard.vue';
Vue.component('parent-subject-upload-card', ParentSubjectUploadCard);